import * as $rdf from 'rdflib'
import * as SolidLogic from 'solid-logic'
import * as UI from 'solid-ui'

const w: any = window
w.$rdf = $rdf
w.SolidLogic = SolidLogic
w.UI = UI
